import React, { useState } from "react";
import {
  Box,
  Avatar,
  Popover,
  Button,
  Stack,
  Typography,
  Drawer,
  Divider,
  Dialog,
  DialogActions,
  DialogTitle
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import LoginModal from "../components/common/LoginModal";
import { logoutUser } from "../redux/reducers/userReducer";
import GradientButton from "../components/common/GradiantButton";
import SecondaryButton from "../components/common/SecondaryButton";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";

const ProfileScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const userData = useSelector((state) => state.user);
  const isVerified = useSelector((state)=>state.user.isVerified);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [openListing, setOpenListing] = useState(false);

  /* ================= HANDLERS ================= */

  const handleClick = (event) => {
    if (isMobile) {
      setDrawerOpen(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setDrawerOpen(false);
  };

  const handleLoginOpen = () => {
    handleClose();
    setTimeout(() => setOpenLoginModal(true), 200);
  };
   const handleAddClick = () => {
    if (isAuthenticated) {
      handleClose();
      navigate("/post-your-property");
    } else {
      handleClose();
      setTimeout(() => {
        setOpenLoginModal(true);
      }, 200); // allow drawer to close first
    }
  };

  const handleMyProfile = () => {
    handleClose();
    navigate("/myprofile", { state: { userData } });
  };


    const handleConfirmLogout = () => {
      dispatch(logoutUser());
      localStorage.removeItem("token");
      navigate("/");
      setOpenLogoutDialog(false);
    };

  /* ================= UI ================= */

  return (
    <>
      {/* Avatar */}
     <Box
  sx={{
    pl: { xs: 1, sm: 2 },
    pr: { xs: 1.5, sm: 0 },
    py: 2,
    cursor: "pointer",
  }}
  onClick={handleClick}
>
  <Box
    sx={{
      width: { xs: 36, sm: 46 },
      height: { xs: 36, sm: 46 },
      borderRadius: "50%",
      border: "2px solid #e0e0e0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Avatar
      alt="User"
      src={userData?.avatar}
      sx={{
        width: { xs: 30, sm: 38 },
        height: { xs: 30, sm: 38 },
      }}
    />
  </Box>
</Box>


<Popover
  open={!isMobile && Boolean(anchorEl)}
  anchorEl={anchorEl}
  onClose={handleClose}
  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  transformOrigin={{ vertical: "top", horizontal: "right" }}
  PaperProps={{
    sx: {
      width: 260,
      borderRadius: 2,
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
      p: 1
    }
  }}
>
  {!isAuthenticated ? (
    <Stack spacing={2} p={2}>
      <Typography fontWeight={600} textAlign="center">
        Welcome to E & J Global Realtors
      </Typography>
      <Button variant="contained" onClick={handleLoginOpen}>
        Login
      </Button>
    </Stack>
  ) : (
    <>
      {/* Header */}
      <Box sx={{ px: 2, py: 1.5 }}>
        <Typography fontWeight={600}>
          {userData?.firstName || "User"}
        </Typography>
        <Typography fontSize={13} color="text.secondary">
          +91 {userData?.Mobilenumber}
        </Typography>
      </Box>

      <Divider />

      {/* Menu */}
     <List disablePadding>
  {/* Profile */}
  <ListItemButton onClick={handleMyProfile}>
    <ListItemIcon>
      <PersonOutlineIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText primary="Profile" />
  </ListItemButton>

  <Divider />

  {/* My Listing (Parent) */}
  <ListItemButton onClick={() => setOpenListing(!openListing)}>
    <ListItemIcon>
      <HomeWorkOutlinedIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText primary="My Listing" />
    {openListing ? <ExpandLess /> : <ExpandMore />}
  </ListItemButton>

  {/* Sub menu */}
  <Collapse in={openListing} timeout="auto" unmountOnExit>
    <List component="div" disablePadding>
      <ListItemButton
        sx={{ pl: 4 }}
        onClick={() => {
          handleClose();
          navigate("/profile/properties");
        }}
      >
        <ListItemText primary="My Properties" />
      </ListItemButton>

      <ListItemButton
        sx={{ pl: 4 }}
        onClick={() => {
          handleClose();
          navigate("/profile/enquiries");
        }}
      >
        <ListItemText primary="Enquiries" />
      </ListItemButton>
       <ListItemButton
        sx={{ pl: 4 }}
        onClick={() => {
          handleClose();
          navigate("/profile/sitevisits");
        }}
      >
        <ListItemText primary="Site Visits" />
      </ListItemButton>
    </List>
  </Collapse>

  <Divider />

  {/* Logout */}
  <ListItemButton
    onClick={() => setOpenLogoutDialog(true)}
    sx={{ color: "error.main" }}
  >
    <ListItemIcon sx={{ color: "error.main" }}>
      <ExitToAppIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText primary="Sign Out" />
  </ListItemButton>
</List>
    </>
  )}
</Popover>

      {/* ================= MOBILE DRAWER ================= */}
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            p: 2,
          },
        }}
      >
        {!isAuthenticated ? (
          <Stack spacing={2}>
            <Typography variant="h6" textAlign="center">
              Welcome to E & J Global Realtors
            </Typography>

            <Divider />

            <Button variant="contained" size="large" onClick={handleLoginOpen}>
              Login
            </Button>

            <Button
                        variant="outlined"
                        size="large"
                        onClick={handleAddClick}
                      >
                        + Post Property (Free)
                      </Button>

          </Stack>
        ) : (
          <Stack spacing={2}>
            <Typography fontWeight={600}>
              {userData?.name || "User"}
            </Typography>
            <Typography fontSize={13} color="text.secondary">
              +91 {userData?.Mobilenumber}
            </Typography>

            <Divider />

            <Button onClick={handleMyProfile}>My Profile</Button>
            <Button color="error" onClick={() => setOpenLogoutDialog(true)}>
              Logout
            </Button>
          </Stack>
        )}
      </Drawer>

      {/* ================= LOGIN MODAL ================= */}
      {openLoginModal && (
        <LoginModal
          open={openLoginModal}
          onClose={() => setOpenLoginModal(false)}
        />
      )}

      <Dialog 
  open={openLogoutDialog} 
  onClose={() => setOpenLogoutDialog(false)}
  PaperProps={{
    sx: {
      borderRadius: '16px',
      boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
      background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
      overflow: 'hidden'
    }
  }}
>
  <Box sx={{ p: 3, textAlign: 'center' }}>
    {/* Icon */}
    <Box sx={{ mb: 2 }}>
      <LogoutIcon 
        sx={{ 
          fontSize: 64, 
          color: '#ff6b6b',
          // background: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%)',
          borderRadius: '50%',
          p: 1,
          boxShadow: '0 4px 20px rgba(255, 107, 107, 0.3)'
        }} 
      />
    </Box>
    
    {/* Title */}
    <DialogTitle 
      sx={{ 
        p: 0, 
        mb: 2,
        fontSize: '1.5rem',
        fontWeight: 600,
        color: '#2d3748'
      }}
    >
      Logout Confirmation
    </DialogTitle>
    
    {/* Message */}
    <Typography 
      variant="body1" 
      sx={{ 
        color: '#718096',
        mb: 0.5,
        lineHeight: 1
      }}
    >
      Are you sure you want to log out?<br />
      You'll need to sign in again to access your account.
    </Typography>
  </Box>

  <DialogActions sx={{ p: 3, gap: 2, justifyContent: 'center' }}>
    {/* <Button 
      onClick={() => setOpenLogoutDialog(false)}
      variant="outlined"
      sx={{
        borderRadius: '12px',
        px: 4,
        py: 1,
        border: '2px solid #e2e8f0',
        color: '#4a5568',
        fontWeight: 600,
        '&:hover': {
          border: '2px solid #cbd5e0',
          backgroundColor: '#f7fafc'
        }
      }}
    >
      Cancel
    </Button> */}
    <SecondaryButton
    text="Cancel"
    onClick={() => setOpenLogoutDialog(false)}/>
    <GradientButton 
    text="Logout"
    onClick={handleConfirmLogout}
    />
    {/* <Button 
      onClick={handleConfirmLogout}
      variant="contained"
      sx={{
        borderRadius: '12px',
        px: 4,
        py: 1,
        background: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%)',
        boxShadow: '0 4px 15px rgba(255, 107, 107, 0.4)',
        fontWeight: 600,
        '&:hover': {
          background: 'linear-gradient(135deg, #ff5252 0%, #ff7b7b 100%)',
          boxShadow: '0 6px 20px rgba(255, 107, 107, 0.6)',
          transform: 'translateY(-1px)'
        },
        transition: 'all 0.3s ease'
      }}
    >
      Logout
    </Button> */}
  </DialogActions>
</Dialog>
    </>
  );
};

export default ProfileScreen;